import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./styles.scss";
import ArrowLink from "components/atoms/arrowLink/index.jsx";
import Button from "components/atoms/button";
import { fetchStock } from "actions/stock";

class StoriesModal extends React.Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    const { stories } = this.props;
    const id = parseInt(this.props.match.params.id);
    const story = stories.find((story) => story.id === id);

    if (!story) {
      return null;
    }

    const nextStory = stories[stories.indexOf(story) + 1];

    return (
      <div className="stories-modal">
        <div className="story">
          <div className=" stories__content">
            <div className="story-full">
              <div className="story-full-data">
                <div className="story-full-data-content">
                  <h4>{story.title}</h4>
                </div>
              </div>
              <div className="story-full-video-preview">
                <video autoPlay onClick={(event) => event.target.play()} loop>
                  <source
                    src={`https://territorioyacopini.com.ar/${story.video_path}`}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
        <div className="overlay"></div>
        <div className="close">
          <div className="close-button ">
            <ArrowLink href="/">Cerrar</ArrowLink>
            {nextStory && (
              <Link to={nextStory.slug_url}>
                <Button buttonText="Siguiente Historia" type="secondary" />
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stories: state.stock.stories,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: () => {
      dispatch(fetchStock());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StoriesModal);
